import * as React from 'react';
import { connect } from 'react-redux';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter, domain } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import { isNullOrUndefined } from 'util';
import Editor from 'react-simple-code-editor';


class RegolaProduct extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showConfirm: false
        }
        this.componentName = '[RegolaProduct.jsx] ';
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

    }


    inputChangeHandler(e) {
        console.log(this.componentName + " inputChangeHandler");
        if (e !== null && e !== undefined) {

            let value = e.target.value;
            let id = e.target.id;
            let type = e.target.type;
            if (value === "[object Object]") {
                value = "";
            }

            if (id === "flServizioDoPrint") {
                this.showRiscLloyds();
            }
            if (id === "idMicroCategoria") {
                let microCategoria = null;
                this.props.getMicroCategorieDetails(value).then(
                    resolve => {
                        microCategoria = resolve;
                        if (microCategoria !== null && microCategoria !== undefined && microCategoria.microCategoriaPacchetto === true) {
                            this.showFlProdottoSoluzione();
                        }
                    }
                );
            }

            if (type === "number" && value === "") {
                value = null;
            }
            if (id == 'idRischioLloyds' && value == '') {
                value = null;
            }
            if (!isNullOrUndefined(type) && type === "radio") {
                id = e.target.name;
            }
           
            this.props.handleChange(id, value).then(
                resolve => {
                    if (id === "fineValidita") {

                        //this.validateDataFine();
                        //if (!isNullOrUndefined(this.props.prodotto.inizioValidita)
                        //    && this.props.prodotto.fineValidita < this.props.prodotto.inizioValidita) {
                           // let validation = new Map();
                           // validation.set("fineValidita", i18n('ARM_CORE_PRODUCT.SHARED.DATA_PRECEDENTE_DALLA_DATA_INIZIO', 'Data Precedente dalla Data inizio'));
                            //this.setState({ validation: validation })
                        //}
                    }
                },
                rejct => {
                    console.log(this.componentName + " handleChange(id, value) -> KO");
                }
            );
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div>
                <div className="row ml-3 mt-2 rowRegolaAnnulli"> 
                <label>{i18n('ARM_CORE_QUEST.SHARED_FILTER_REGOLA_ANNULLI', 'Regola Annulli in Javascript')}</label>
                <Editor
                        textareaClassName="form-control-regola"
                        disabled={this.props.disabled}
                         value={this.props.prodotto.regolaAnnulli}
                        onValueChange={(value) => this.inputChangeHandler(
                            {
                                target: {
                                    value: value,
                                    id: "regolaAnnulli",
                                    name: "regolaAnnulli"
                                }
                            }
                        )}
                        padding={39}
                        highlight={(code) => this.props.prodotto.regolaAnnulli ? Prism.highlight(this.props.prodotto.regolaAnnulli, Prism.languages.javascript, 'javascript') : null}
                        style={{
                            width: "100%",
                            fontFamily: '"Fira code", "Fira Mono", monospace',
                            fontSize: 12,
                            border: "1px solid #ced4da !important",
                            borderRadius: ".25rem !important",
                        }} >
                    </Editor>
                </div> 
                <br></br><br></br><br></br>
            </div>

        )
    }
    ;
}
function mapStateToProps(state) {
    return {
        prodotto: state.prodotto.detailsProdotto,
        prodottoFirmaDigitale: state.prodotto.prodottoFirmaDigitale
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleChange(index, e) {
            return dispatch(ProdottoActions.handleChange(index, e))
        },
        handleChangeFirmaDigitale(index, e) {
            return dispatch(ProdottoActions.handleChangeFirmaDigitale(index, e))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(RegolaProduct);